"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface SubscriptionConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: "pause" | "resume" | "cancel" | null;
  onConfirm: () => void;
}

export function SubscriptionConfirmDialog({
  open,
  onOpenChange,
  action,
  onConfirm,
}: SubscriptionConfirmDialogProps) {
  const getDescription = () => {
    if (action === "pause") {
      return "This will pause the subscription and stop generating new appointments.";
    }
    if (action === "resume") {
      return "This will resume the subscription and continue generating appointments.";
    }
    if (action === "cancel") {
      return "This will cancel the subscription permanently. This action cannot be undone.";
    }
    return "";
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>{getDescription()}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {action === "cancel" ? "Cancel Subscription" : "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

